import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaHoldings = React.lazy(() =>
    import('../NebulaHoldings')
);
const nebulaHoldingsRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_HOLDINGS_PAGE,
        element: <NebulaHoldings />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaHoldingsRoutesRegistry;
